export const Footer = () => (
  <footer className="editorial-footer">
    <div className="container">
      <div className="footer-top">
        <div>
          <a className="footer-brand" href="#">
            <img src="/brand/social.png" width="42" height="42" alt="" />
            <span>EVERFORGE</span>
          </a>
          <p>
            Fitness. Nutrition. Lifestyle.
            <br />
            Build better habits. Create a better life.
          </p>
          <div style={{ marginTop: '16px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>✉️</span>
            <a
              href="mailto:support@everforgefitness.com"
              style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}
              title="Official EVERFORGE Support Email"
            >
              support@everforgefitness.com
            </a>
          </div>
        </div>

        <nav aria-label="Footer coaching links">
          <span>Find your coaching</span>
          <a href="#plans">Compare coaching plans</a>
          <a href="#philosophy">Our approach</a>
          <a href="#consultation">Talk to a coach</a>
        </nav>

        <nav aria-label="Footer support links">
          <span>Support & Inquiries</span>
          <a href="mailto:support@everforgefitness.com">support@everforgefitness.com</a>
          <a href="https://everforge.web.app" target="_blank" rel="noopener noreferrer">
            Client login ↗
          </a>
          <a href="#faq">Questions & answers</a>
          <a href="#pricing">Pricing & commitments</a>
        </nav>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} EVERFORGE Fitness · All rights reserved.</span>
        <span>
          Online coaching · Direct support:{' '}
          <a
            href="mailto:support@everforgefitness.com"
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >
            support@everforgefitness.com
          </a>
        </span>
      </div>
    </div>
  </footer>
);
